// import Header from "./Conponents/Header";
// import FoodOption from "./Conponents/FoodOption";
// import Grocery from "./Conponents/GroceryOption";
// import DineOption from "./Conponents/DineOption";
import Header from "./Header"
import FoodOption from "./FoodOption";
import Grocery from "./GroceryOption";
import DineOption from "./DineOption";
export default function Home(){
    return(
        <>
        <Header></Header>
        <FoodOption></FoodOption>
        <Grocery></Grocery>
        <DineOption></DineOption>
        </>
    )
}